import { main } from "./build/Main/index.js";
main();
